module.exports = __webpack_public_path__ + "img/Saved.3061e006.png";